/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { useDebugHydration, useForceHydration } from './selectors'

const green = {
  background: '#eeffee',
  '&>*': { background: '#eeffee !important' },
}
const red = {
  background: '#ffeeee',
  '&>*': { background: '#ffeeee !important' },
}

export const RedWrapper = (props) => {
  const debugHydration = useDebugHydration()
  return <span {...props} sx={debugHydration ? red : {}} />
}
export const GreenWrapper = (props) => {
  const debugHydration = useDebugHydration()
  return <span {...props} sx={debugHydration ? green : {}} />
}

const ConditionalHydrate = ({ As = 'span', force = false, children, ...props }) => {
  const isServer = typeof window === 'undefined'
  const debugHydration = useDebugHydration()
  const forceHydrationHookVal = useForceHydration()
  const forceHydration = force || forceHydrationHookVal

  return (
    <Choose>
      {/* Rendered on the server */}
      <When condition={isServer}>
        <As sx={debugHydration ? green : {}} className={props.className} {...props}>
          {children}
        </As>
      </When>

      {/* Hydrated in the browser */}
      <When condition={forceHydration}>
        <As sx={debugHydration ? red : {}} className={props.className} {...props}>
          {children}
        </As>
      </When>

      {/* NOT hydrated in the browser */}
      <Otherwise>
        <As
          className={props.className}
          dangerouslySetInnerHTML={{ __html: '' }}
          suppressHydrationWarning
          {...props}
        />
      </Otherwise>
    </Choose>
  )
}

export default ConditionalHydrate
